import React, { Component } from 'react';
import '../../App.css';
import '../../styles/app-demo.css';
import allTransactions from '../../assets/mobile-app/all-transactions.png';

class Transactions extends Component {

  constructor(props){
    super(props)
    this.toggleNewRoute = this.toggleNewRoute.bind(this);
  }

  toggleNewRoute() {
    this.props.toggleNewRoute('dashboard');
  }

  render() {

    return (
      <section>
        <div className="fintwist-interactive-mobile">
        <section className="mobile-app-wrapper">
          <div className="orange-header">
            <i onClick={this.toggleNewRoute} className="fa fa-angle-left"></i>
            <h2>Transactions</h2>
          </div>
          <div className="mobile-app-dashboard">
            <img id="all-transactions-image" src={allTransactions} alt={''} />
          </div>
        </section>
        </div>
      </section>
    );
  }
}

export default Transactions;
